interface LoadingOverlayProps {
  readonly isLoading: boolean;
}

export default function LoadingOverlay({ isLoading }: LoadingOverlayProps) {
  if (!isLoading) {
    return null;
  }

  return (
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center bg-gray-100 bg-opacity-90 z-20 rounded-lg px-6 py-4 shadow-lg">
      <div className="text-lg">Loading...</div>
    </div>
  );
}
